const Form2 = ({ state, changeHandler, nextHandler }) => {

  const data = [
    {
      value: '20s',
      image: "/assets/age1.png",
      image2: "/assets/agem1.png",
    },
    {
      value: '30s',
      image: "/assets/age2.png",
      image2: "/assets/agem2.png",
    },
    {
      value: '40s',
      image: "/assets/age3.png",
      image2: "/assets/agem3.png",
    },
    {
      value: '50s',
      image: "/assets/age4.png",
      image2: "/assets/agem4.png",
    }
  ]

  const clickHandler = (value) => {
    changeHandler({
      age_group: value,
    });
    nextHandler();
  }
  return (
    <div className="programsContainer programsContainer2">
        <div className="fo-26 bco text-center fw-700 mfo-22">What's your age group?</div>

          {state.gender == 'Female' ? (
            <div className="row m-0 mt-4 genderSelection">
              { data.map((elem, index) => <Card key={index} value={elem.value} image={elem.image} clickHandler={clickHandler} />) }
            </div>
          ) : (
            <div className="row m-0 mt-4 genderSelection">
              { data.map((elem, index) => <Card key={index} value={elem.value} image={elem.image2} clickHandler={clickHandler} />) }
            </div>
          )}

    </div>
  )
}

export default Form2;

const Card = ({ image, value, clickHandler }) => {
  return(
    <div className="col-6 col-sm-6 ms-auto me-auto mb-4 text-center" onClick={() => clickHandler(value)}>
      <div className="bmr_image m-auto">
        <img src={image} className="w-100 m-auto" alt="age1"></img>
      </div>
      <div className="text-center mt-3 blogCategoryTitle fw-600" >{value}</div>
    </div>
  )
}
